import { render, staticRenderFns } from "./tablePtenDeduplicate.vue?vue&type=template&id=1b58b4a7&scoped=true"
import script from "./tablePtenDeduplicate.vue?vue&type=script&lang=js"
export * from "./tablePtenDeduplicate.vue?vue&type=script&lang=js"
import style0 from "./tablePtenDeduplicate.vue?vue&type=style&index=0&id=1b58b4a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b58b4a7",
  null
  
)

export default component.exports